"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatus = void 0;
/**
 * Allows you to get the current status of this service
 */
var getStatus = function (instance) { return function (config) {
    return instance.get("/suppliers/status", config);
}; };
exports.getStatus = getStatus;
